import React from 'react'
import { Job, JobWizardMobile } from 'sprockets_react/job_wizards/registries'
import $ from 'sprockets_react/job_wizards/jquery'

JobWizardMobile.SelectLocation = {
  onSubmit: function(onStepProgression, onRequest, onRequestCompletion, onStepRetreat) {
    if (Job.Data.backToSubmit === true){
      JobWizardMobile.Emitter.emit('job:wizard:advanceToStep', JobWizardMobile.JobSummary)
    }
    else {
      if (Job.Data.referrer.cta === 'profile') {
        this.checkViewedBusiness()
      } else {
        onStepProgression()
      }
    }
  },

  onLeftNavButtonClick(onStepProgression) {
    JobWizardMobile.Emitter.emit('job:wizard:advanceToStep', JobWizardMobile.SelectCategory)
  },

  hasSuburb() {
    return Job.Data.suburb_id !== 0
  },

  checkViewedBusiness() {
    $.ajax({
      url: '/job_wizard/check_viewed_business',
      method: 'GET',
      data: { subcategory_id: Job.Data.category_id, suburb_id: Job.Data.suburb_id, business_id: Job.Data.exclusiveFor }
    })
    .done((data) => {
      if (data.viewed_business_matched) {
        JobWizardMobile.Emitter.emit('job:wizard:advanceToStep', JobWizardMobile.EnterDescription)
      } else {
        JobWizardMobile.Emitter.emit('job:wizard:advanceToStep', JobWizardMobile.MatchedBusiness)
      }
    })
  },

  component: React.createClass({
    render(){
      return (
        <div className="form-horizontal">
          <div className="form-group mb30">
            <div className="col-xs-12 visible-xs details-mobile">
              <h3 className="mt10">Where do you need the job done?</h3>
              <div className="font-14 text-copy-0 pb5">Enter Postcode or Suburb</div>
              <div className="input-group p5 border radius-6">
                <JobWizardMobile.Location />
                <span className="input-group-btn">
                  <JobWizardMobile.NavigationButtons
                    navButtonLayout='okButton'
                    onStepProgression={this.props.onStepProgression}
                  />
                </span>
              </div>
            </div>
          </div>
        </div>
      )
    }
  })
}
